/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

import { D3ChartSvgg, D3XScale } from '@shared/types/common-graph.types';

import { ChartNowLineConfig } from '../chart.view-model';

@Injectable()
export class NowLineService {
  public generateNowLine(
    linesContainer: D3ChartSvgg,
    config: ChartNowLineConfig,
    height: number,
    xScale: D3XScale,
    topOverflow: number,
    bottomOverflow: number,
    strokeColorClass?: string
  ): void {
    const xMin = DateTime.fromJSDate(xScale.domain()[0]);
    const xMax = DateTime.fromJSDate(xScale.domain()[1]);
    const lineYOffset = 6;

    let now = config.now;

    if (config.offsetXMillis) {
      now = now.plus({ milliseconds: config.offsetXMillis });
    }

    const xPoint = xScale(now);

    const strokeColor = strokeColorClass || 'stroke-foreground-primary-100';

    if (now >= xMin && now <= xMax) {
      linesContainer
        .append('g')
        .call((g) =>
          g
            .append('line')
            .attr('x1', xPoint - 15)
            .attr('x2', xPoint + 15)
            .attr('y1', -1 * topOverflow)
            .attr('y2', -1 * topOverflow)
            .attr('class', strokeColor)
            .attr('stroke-width', 2)
        )
        .call((g) =>
          g
            .append('line')
            .attr('x1', xPoint)
            .attr('x2', xPoint)
            .attr('y1', -1 * topOverflow)
            .attr('y2', height + lineYOffset + bottomOverflow)
            .attr('stroke-dasharray', '8, 8')
            .attr('class', strokeColor)
            .attr('stroke-width', 2)
        )
        .call((g) =>
          g
            .append('line')
            .attr('x1', xPoint - 15)
            .attr('x2', xPoint + 15)
            .attr('y1', height + lineYOffset + bottomOverflow)
            .attr('y2', height + lineYOffset + bottomOverflow)
            .attr('class', strokeColor)
            .attr('stroke-width', 2)
        );
    }
  }
}
